export const UNKNOWN_SERVER_ERROR_MSG = 'Unexpected server error'
export const UNKNOWN_SERVER_ERROR_CTA_MSG = 'Please try again'
